import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { Message } from 'element-ui'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '项目概况', icon: 'el-icon-data-line', requireCompanyManager: true }
      },
      {
        path: 'project',
        name: 'ProjectList',
        component: () => import('@/views/project/index.vue'),
        meta: { title: '项目查询', icon: 'el-icon-folder' }
      },
      {
        path: 'project/contract',
        name: 'ContractGenerator',
        component: () => import('@/views/project/ContractGenerator.vue'),
        meta: { title: '合同生成', icon: 'el-icon-document', requireCompanyManager: true }
      },
      {
        path: 'project/doc',
        name: 'ProjectDoc',
        component: () => import('@/views/project/ProjectDoc.vue'),
        meta: { title: '项目文档', icon: 'el-icon-folder-opened', requireProjectDoc: true }
      },
      {
        path: 'project/quotation',
        name: 'QuotationGenerator',
        component: () => import('@/views/project/QuotationGenerator.vue'),
        meta: { title: '报价单生成', icon: 'el-icon-s-marketing', requireCompanyManager: true }
      },
      {
        path: 'project/weekly',
        name: 'WeeklyReportGenerator',
        component: () => import('@/views/project/WeeklyReportGenerator.vue'),
        meta: { title: '周报生成', icon: 'el-icon-document-checked', requireCompanyManager: true }
      },
      {
        path: 'project/member/:projectId',
        name: 'ProjectMember',
        component: () => import('@/views/project/ProjectMember.vue'),
        meta: { title: '项目成员' },
        hidden: true
      },
      {
        path: 'project/detail/:projectId',
        name: 'ProjectDetail',
        component: () => import('@/views/project/ProjectDetail.vue'),
        meta: { title: '项目详情' },
        hidden: true
      },
      {
        path: 'finance',
        name: 'Finance',
        component: () => import('@/views/finance/index.vue'),
        meta: { title: '收支查询', icon: 'el-icon-money', requireCompanyManager: true }
      },
      {
        path: 'finance/invoice',
        name: 'InvoiceManage',
        component: () => import('@/views/finance/InvoiceManage.vue'),
        meta: { title: '发票开具', icon: 'el-icon-tickets', requireCompanyManager: true }
      },
      {
        path: 'finance/payment',
        name: 'PaymentManage',
        component: () => import('@/views/finance/PaymentManage.vue'),
        meta: { title: '收款一览', icon: 'el-icon-wallet', requireCompanyManager: true }
      },
      {
        path: 'finance/expense',
        name: 'ExpenseManage',
        component: () => import('@/views/finance/ExpenseManage.vue'),
        meta: { title: '项目成本', icon: 'el-icon-coin', requireCompanyManager: true }
      },
      {
        path: 'finance/reimbursement',
        name: 'ReimbursementManage',
        component: () => import('@/views/finance/ReimbursementManage.vue'),
        meta: { title: '报销管理', icon: 'el-icon-s-order', requireCompanyManager: true }
      },
      {
        path: 'finance/salary',
        name: 'SalaryManage',
        component: () => import('@/views/finance/SalaryManage.vue'),
        meta: { title: '工资维护', icon: 'el-icon-bank-card', requireCompanyManager: true }
      },
      {
        path: 'finance/monthlySalary',
        name: 'MonthlySalary',
        component: () => import('@/views/finance/MonthlySalary.vue'),
        meta: { title: '月度工资确认', icon: 'el-icon-calendar', requireCompanyManager: true }
      },
      {
        path: 'finance/business',
        name: 'BusinessAnalysis',
        component: () => import('@/views/finance/BusinessAnalysis.vue'),
        meta: { title: '经营状况分析', icon: 'el-icon-data-analysis', requireCompanyManager: true }
      },
      {
        path: 'finance/costAnalysis',
        name: 'CostAnalysis',
        component: () => import('@/views/finance/CostAnalysis.vue'),
        meta: { title: '项目成本分析', icon: 'el-icon-pie-chart', requireCompanyManager: true }
      },
      {
        path: 'workhour',
        name: 'WorkHour',
        component: () => import('@/views/workhour/index.vue'),
        meta: { title: '日报查询', icon: 'el-icon-time' }
      },
      {
        path: 'workhour/calendar',
        name: 'WorkHourCalendar',
        component: () => import('@/views/workhour/WorkHourCalendar.vue'),
        meta: { title: '日报录入', icon: 'el-icon-edit' }
      },
      {
        path: 'attendance/leave',
        name: 'LeaveCalendar',
        component: () => import('@/views/attendance/LeaveCalendar.vue'),
        meta: { title: '休假审批', icon: 'el-icon-date', requireCompanyManager: true }
      },
      {
        path: 'workhour/detail/:projectId',
        name: 'WorkHourDetail',
        component: () => import('@/views/workhour/WorkHourDetail.vue'),
        meta: { title: '日报详情' },
        hidden: true
      },
      {
        path: 'wbs',
        name: 'Wbs',
        component: () => import('@/views/wbs/index.vue'),
        meta: { title: 'WBS分配', icon: 'el-icon-s-operation', requireWbs: true }
      },
      {
        path: 'wbs/detail/:projectId',
        name: 'WbsDetail',
        component: () => import('@/views/wbs/WbsDetail.vue'),
        meta: { title: 'WBS详情' },
        hidden: true
      },
      {
        path: 'utilization',
        name: 'UtilizationStats',
        component: () => import('@/views/project/UtilizationStats.vue'),
        meta: { title: '稼动率统计', icon: 'el-icon-data-analysis', requireCompanyManager: true }
      },
      {
        path: 'workhour/stats',
        name: 'WorkHourStats',
        component: () => import('@/views/workhour/WorkHourStats.vue'),
        meta: { title: '工时统计' },
        hidden: true
      },
      {
        path: 'defect',
        name: 'DefectManage',
        component: () => import('@/views/defect/DefectManage.vue'),
        meta: { title: '缺陷管理', icon: 'el-icon-bug' }
      },
      {
        path: 'system/user',
        name: 'UserManage',
        component: () => import('@/views/system/UserManage.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user', requireAdmin: true }
      },
      {
        path: 'system/role',
        name: 'RoleManage',
        component: () => import('@/views/system/RoleManage.vue'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom', requireAdmin: true }
      },
      {
        path: 'system/permission',
        name: 'PermissionManage',
        component: () => import('@/views/system/PermissionManage.vue'),
        meta: { title: '权限管理', icon: 'el-icon-lock', requireAdmin: true }
      },
      {
        path: 'system/taskContent',
        name: 'TaskContentManage',
        component: () => import('@/views/system/TaskContentManage.vue'),
        meta: { title: '作业内容', icon: 'el-icon-menu', requireAdmin: true }
      },
      {
        path: 'system/operationLog',
        name: 'OperationLog',
        component: () => import('@/views/system/OperationLog.vue'),
        meta: { title: '操作日志', icon: 'el-icon-document', requireAdmin: true }
      },
      {
        path: 'system/holiday',
        name: 'HolidayManage',
        component: () => import('@/views/system/HolidayManage.vue'),
        meta: { title: '节假日管理', icon: 'el-icon-date', requireAdmin: true }
      },
      {
        path: 'project/customer',
        name: 'CustomerManage',
        component: () => import('@/views/system/CustomerManage.vue'),
        meta: { title: '客户管理', icon: 'el-icon-office-building', requireCompanyManager: true }
      },
      {
        path: 'project/demander',
        name: 'DemanderManage',
        component: () => import('@/views/project/DemanderManage.vue'),
        meta: { title: '需求方管理', icon: 'el-icon-s-flag', requireCompanyManager: true }
      },
      {
        path: 'szy/convert',
        name: 'FormatConvert',
        component: () => import('@/views/szy/FormatConvert.vue'),
        meta: { title: '格式转换', icon: 'el-icon-refresh', requireCompanyManager: true }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title + ' - 兴沈软件项目开发管理平台' : '兴沈软件项目开发管理平台'
  // 企业微信移动端打开 PC 路由时，转到对应 H5 页面
  const ua = navigator.userAgent
  const isMobileWecom = /wxwork/i.test(ua) && /Android|iPhone|iPad|iPod|Mobile/i.test(ua)
  if (isMobileWecom && to.path === '/attendance/leave') {
    window.location.replace('/wecom/leave.html')
    return
  }
  const token = store.getters.token
  if (to.path === '/login') {
    next()
  } else if (!token) {
    // 记录原始入口路径，登录（含企微免登）后跳回
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else if (to.path === '/home') {
    // 首页重定向：公司管理者进项目概况，其他进日报录入
    next(store.getters.isCompanyManager ? '/dashboard' : '/workhour/calendar')
  } else if (to.meta.requireAdmin && !store.getters.isAdmin) {
    // 非管理员访问系统管理页面
    Message.warning('您没有权限访问该页面')
    next(from.path !== to.path ? from.fullPath : '/project')
  } else if (to.meta.requireCompanyManager && !store.getters.isCompanyManager) {
    // 非公司管理者访问项目概况，重定向到项目管理
    Message.warning('您没有权限访问该页面')
    next('/project')
  } else if (to.meta.requireWbs && !store.getters.isCompanyManager && !store.getters.isProjectManager) {
    // WBS分配仅公司管理者与项目经理可访问
    Message.warning('您没有权限访问该页面')
    next('/project')
  } else if (to.meta.requireProjectDoc && !store.getters.isCompanyManager && !store.getters.isProjectManager) {
    // 项目文档仅公司管理者与项目经理可访问
    Message.warning('您没有权限访问该页面')
    next('/project')
  } else {
    next()
  }
})

export default router
